
const generateICS = (startDate : Date, duration : number, title?: string, description?: string, location ?: string) => {
    // Calculate end date based on start date and duration
    const endDate = new Date(startDate.getTime() + duration * 60000);

    // Format dates as strings in the required format (YYYYMMDDTHHMMSSZ)
    const formatICSDate = (date : Date) => {
      return date.toISOString().replace(/[:-]/g, '').replace(/\.\d{3}Z$/, 'Z');
    };

    // Construct the iCalendar string
    const icsString = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${formatICSDate(startDate)}
DTEND:${formatICSDate(endDate)}
SUMMARY:${title ?? ""}
DESCRIPTION:${description ?? ""}
LOCATION:${location ?? ""}
END:VEVENT
END:VCALENDAR`;

    // Create a blob from the string
    const blob = new Blob([icsString], { type: 'text/calendar;charset=utf-8' });
    const icsUrl = window.URL.createObjectURL(blob);
    const webcalURL = icsUrl.replace('http:', 'webcal:');

    // Attempt ICS file download with iframe
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = webcalURL;
    document.body.appendChild(iframe);

    setTimeout(() => {
      document.body.removeChild(iframe);
      const link = document.createElement('a');
      link.href = icsUrl;
      link.setAttribute('download', 'event.ics');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(icsUrl)
    }, 2000)

    // // Create a download link and trigger the download
    // const link = document.createElement('a');
    // link.href = window.URL.createObjectURL(blob);
    // link.setAttribute('download', 'event.ics');
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

}

export default generateICS
